import cookieConsent from 'honeycomb-web-toolkit/src/cookie-consent/js/honeycomb.cookie-consent';

cookieConsent.init({
    banner: {
        heading: 'Cookies on red-gate.com',
        links: [
            {
                title: 'Privacy notice',
                href: '/trust/privacy-notice',
            },
        ],
    },
    consentGroups: [
        // 'functional', // Removing functional for now, as we don't have any yet.
        'performance',
        'targeting',
    ],
    cookie: {
        name: 'rgcookieconsent',
        domain: '.red-gate.com',
    },
});

// Expose on window so app.js can reference it without re-bundling.
window.cookieConsent = cookieConsent;

// Ensure the cookie banner is inside a landmark region so all page content is contained by landmarks (axe "region" rule).
const applyBannerLandmark = (banner) => {
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', 'Cookie consent');
};

const existingBanner = document.querySelector('.cookie-consent');
if (existingBanner) {
    applyBannerLandmark(existingBanner);
} else {
    // The banner is appended as a direct child of <body>, so childList: true on
    // document.body is sufficient. Dropping subtree: true avoids triggering the
    // callback on every DOM mutation across the entire page.
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('cookie-consent')) {
                    applyBannerLandmark(node);
                    observer.disconnect();
                    return;
                }
            }
        }
    });
    observer.observe(document.body, { childList: true });
}
